import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import Button from '@/components/primitives/Button.jsx';
import Input from '@/components/primitives/Input.jsx';
import loadSignedInContext from '@/redux/actions/sessionActions/loadSignedInContext.js';
import { signUpWithPassword } from '@/redux/requests/sessionRequests.js';
import AuthLayout from '../components/AuthLayout.jsx';
import AuthNotice from '../components/AuthNotice.jsx';
import describeAuthFailure from '../lib/describeAuthFailure.js';
import MIN_PASSWORD_LENGTH from '../lib/MIN_PASSWORD_LENGTH.js';

/** Creates an account and its personal workspace, then hands over to first-run setup. */
const SignUpPage = () => {
  const dispatch = useDispatch();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isPasswordShort = password.length > 0 && password.length < MIN_PASSWORD_LENGTH;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setIsSubmitting(true);
    const res = await signUpWithPassword({ email: email.trim(), password, name: name.trim() || undefined });

    if (res?.success === false) {
      setIsSubmitting(false);
      setError(describeAuthFailure(res));
      return;
    }

    dispatch(loadSignedInContext({ companyId: res?.user?.companyId }));
  };

  return (
    <AuthLayout
      title="Create your Pieve account"
      description="Describe the outcome you want. Pieve does the work in your apps."
      footer={
        <>
          Already have an account?{' '}
          <Link className="auth-link" to="/sign-in">
            Sign in
          </Link>
        </>
      }>
      <form className="auth-form" onSubmit={handleSubmit} noValidate>
        <AuthNotice>{error}</AuthNotice>
        <Input label="Your name" name="name" autoComplete="name" value={name} onChange={(event) => setName(event.target.value)} />
        <Input label="Work email" type="email" name="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} required />
        <Input label="Password" type="password" name="password" autoComplete="new-password" value={password} onChange={(event) => setPassword(event.target.value)} hint={isPasswordShort ? undefined : `At least ${MIN_PASSWORD_LENGTH} characters.`} error={isPasswordShort ? `Use at least ${MIN_PASSWORD_LENGTH} characters.` : undefined} required />
        <div className="auth-form__submit">
          <Button type="submit" variant="primary" size="lg" loading={isSubmitting} disabled={!email.trim() || password.length < MIN_PASSWORD_LENGTH}>
            Create account
          </Button>
        </div>
      </form>
    </AuthLayout>
  );
};

export default SignUpPage;
